"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localTime = exports.dateTime = exports.gregorianDate = void 0;
const classes_1 = require("../dates/classes");
const BasicDecode = __importStar(require("./basicDecode"));
const errors_1 = require("./errors");
const TIME_REGEX = /^(\d\d):(\d\d)(?::(\d\d)(?:\.(\d{3,6}))?)?$/;
exports.gregorianDate = BasicDecode.map(BasicDecode.string, (str) => {
    try {
        return classes_1.GregorianDate.fromISOString(str);
    }
    catch (error) {
        const { message } = error;
        throw new errors_1.DecodeError(message);
    }
});
exports.dateTime = BasicDecode.map(BasicDecode.string, (str) => {
    try {
        return classes_1.DateTime.fromISOString(str);
    }
    catch (error) {
        const { message } = error;
        throw new errors_1.DecodeError(message);
    }
});
exports.localTime = BasicDecode.map(BasicDecode.string, (str) => {
    const match = str.match(TIME_REGEX);
    if (match === null) {
        throw new errors_1.DecodeError(`Expected ISO 8601 time, got ${str}`);
    }
    const [, hour, minute, second, millisecond] = match;
    return new classes_1.LocalTime(Number.parseInt(hour, 10), Number.parseInt(minute, 10), second ? Number.parseInt(second, 10) : 0, millisecond ? Number.parseInt(millisecond, 10) : 0);
});
//# sourceMappingURL=domainDecode.js.map